module.exports = __webpack_public_path__ + "img/activity_title.fd6bab1d.png";